<template>
  <div class="accordion accordion-single" :class="{ active }">
    <div class="accordion-title" @click="toggle">
      <slot name="title" :active="active" />
      <button class="btn btn-circle">
        <img class="rotate-90" src="@/asset/icon/arrow-single-right-green.svg" alt="">
      </button>
    </div>
    <div class="accordion-content">
      <div class="content-wrapper">
        <slot name="content" :active="active" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const state = defineProps({
  opened: {
    type: Boolean,
    default: false,
  },
});

const active = ref(state.opened);

const toggle = () => {
  active.value = !active.value;
};
</script>
